module.exports = __webpack_public_path__ + "static/img/Group 49@2x.375686f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/return/Group 49@2x.png
// module id = z4Uj
// module chunks = 1